import { generateState } from '../builder'

export default {
  aiPrompts: [],
  aiPrompt: {},
  ...generateState('getAiPrompts'),
  ...generateState('getAiPrompt'),
  ...generateState('saveAiPrompt'),
}
